import RcmpModalAdd from "../../molecules/ModalAdd";
import styles from './index.module.scss'
import PurePlusIcon from "../../../assets/icons/PurePlusIcon";
import { Typography } from "@stardust-ds/react";
import RcmpTableFormList from "../TableFormList";
import RcmpHistory from "../../molecules/History";
import intl from "react-intl-universal"
import { useContext, useState } from "react";
import RcmpLoading from "../../atoms/Loading";
import Modal from "../../molecules/Modal";
import moment from "moment";
import AuthContext from "../../../contexts/Auth";


function RcmpHistoryModal(props) {
    const { cTitle, bIsOpen, fnOnClose, aHeaders, fnGetHistory, fnFormatTextHistory, cException, cTargetHistoryType, nTargetId } = props
    return (
        <Modal isOpen={bIsOpen} size={"lg"} className={styles.modalHistoryContainer}>
            <Modal.Header className={styles.modalContainer} onClose={fnOnClose}>{cTitle}</Modal.Header>
            <Modal.Content className={styles.modalContent}>
                <RcmpHistory cTargetHistoryType={cTargetHistoryType} nTargetId={nTargetId} aHeaders={aHeaders} fnGetHistory={fnGetHistory} fnFormatTextHistory={fnFormatTextHistory} />
            </Modal.Content>
        </Modal>
    )
}

export default function RcmpModalList(props) {
    const { bIsOpen, bOnClose, aData, bIsAutomation, title, cCreateNewFunctionality, fnOpenModalNewFunctionality, bDataLoadingRequest, fnGetHistory, bCanChange } = props
    const aHeadersHistoryTable = [intl.get("automation_list_activities.date"), intl.get("automation_list_activities.users"), intl.get("automation_list_activities.type"), intl.get("automation_list_activities.change")]
    const [bIsOpenModalHistory, fnSetBIsOpenModalHistory] = useState(false)
    const [oCurrentHistoryData, fnSetOCurrentHistoryData] = useState({})

    const { oUser } = useContext(AuthContext)
    const cUserTimezone = oUser?.data?.user_ctimezone || "America/Sao_Paulo"
    function fnCloseModal() {
        bOnClose()
    }

    function fnTranslateNewValues(data) {
        const aValues = ["day", "month", "week", "minutes", "hour", "hours"];
        let oValues = undefined
        const findMatchingValue = (array, value) => {
            const lowerCaseValue = value?.toLowerCase();
            return array.find(item => item?.toLowerCase() === lowerCaseValue || item?.toLowerCase() === `${lowerCaseValue}s`);
        };
        const matchingValueNew = findMatchingValue(aValues, data.opht_cnew_value);
        const matchingValueOld = findMatchingValue(aValues, data.opht_cold_value);
        if (matchingValueNew) {
            oValues = { opht_cnew_value: intl.get(`modal_new_form.${matchingValueNew}`) }
        }
        if (matchingValueOld) {
            oValues = {
                ...oValues,
                opht_cold_value: intl.get(`modal_new_form.${matchingValueOld}`)
            }
        }
        if(!matchingValueNew || !matchingValueOld){
            oValues = {opht_cnew_value: data.opht_cnew_value, opht_cold_value: data.opht_cold_value}
        }
        return oValues;
    }


    function fnFormatAutomationTextHistory(data, cAction) {
        const oResponseTranslate = fnTranslateNewValues(data)
        if (cAction === "created" && data.opht_changeable_type === "Automation") {
            return intl.get("modal_automation_list.history.create_message", {functionality: intl.get("modal_automation_list.history.automation")})
        }
        
        if (cAction === "created" && data.opht_changeable_type === "AutomationRecipient") {
            const cEmailUserExtern = data.opht_cnew_value.includes('|') ? data.opht_cnew_value.split('|')[1] : null
            const cNewValue = data.opht_cnew_value.includes('|') ? data.opht_cnew_value.split('|')[0] : null
            if (data.opht_cfield === "opar_crecipinent_name")
                return intl.get("modal_automation_list.history.update_message_not_old_extern", {
                    field: intl.get("modal_new_automation.notification_params.name"),
                    newValue: cNewValue ?? data.opht_cnew_value,
                    email: cEmailUserExtern ?? ""
                })
                if(data.opht_cfield === "opar_user_nid"){
                    return intl.get("modal_automation_list.history.update_message_not_old", {
                        field: intl.get("modal_new_automation.notification_params.user_notificade"),
                        newValue: data.opht_cnew_value
                    })
                }
        }
        if (cAction === "update" && data.opht_cfield === "opa_notf_nid" && data.opht_cnew_value !== null) {
            return intl.get("modal_automation_list.history.stopped_mesage")
        }
        if (cAction === "update" && data.opht_cfield === "opa_notf_nid" && !data.opht_cnew_value) {
            return intl.get("modal_automation_list.history.returned_message")
        }
        if (cAction === "update" && data.opht_changeable_type === "AutomationFieldValue") {
            return intl.get("modal_automation_list.history.update_message", {
                field: data.opht_cfield,
                oldValue: data.opht_cold_value,
                newValue: data.opht_cnew_value
            })
        }
        if (cAction === "update" && (data.opht_changeable_type === "Automation" || data.opht_changeable_type === "AutomationRecipient")) {
            switch (data.opht_cfield) {
                case "opa_ctitle":
                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("modal_new_automation.automatio_title"),
                        oldValue: data.opht_cold_value,
                        newValue: data.opht_cnew_value
                    });

                case "opa_ctype":
                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("modal_new_automation.automation_type"),
                        oldValue: data.opht_cold_value,
                        newValue: data.opht_cnew_value
                    })

                case "opa_ntime_repeat_value":
                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("modal_new_automation.repeat_each"),
                        oldValue: data.opht_cold_value,
                        newValue: data.opht_cnew_value
                    })

                case "opa_ctime_repeat_range":
                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("modal_new_automation.repeat_time"),
                        oldValue: oResponseTranslate.opht_cold_value || data.opht_cold_value,
                        newValue: oResponseTranslate.opht_cnew_value || data.opht_cnew_value
                    })

                case "opa_dstart_repeat_date":
                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("modal_new_automation.start_date"),
                        oldValue: moment(data.opht_cold_value).format("DD/MM/YYYY"),
                        newValue: moment(data.opht_cnew_value).format("DD/MM/YYYY")
                    })


                case "Data e hora de início":

                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("modal_new_automation.starting_from"),
                        oldValue: moment.utc(data.opht_cold_value, "YYYY/MM/DD - HH:mm").tz(cUserTimezone).format("DD/MM/YYYY - HH:mm"),
                        newValue: moment.utc(data.opht_cnew_value, "YYYY/MM/DD - HH:mm").tz(cUserTimezone).format("DD/MM/YYYY - HH:mm")

                    })

                case "opa_ndeadline_value":
                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("modal_new_automation.deadline_execution"),
                        oldValue: data.opht_cold_value,
                        newValue: data.opht_cnew_value
                    })

                case "opa_cdeadline_range":
                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("modal_new_automation.deadline_execution"),
                        oldValue: oResponseTranslate.opht_cold_value || data.opht_cold_value,
                        newValue: oResponseTranslate.opht_cnew_value || data.opht_cnew_value
                    })

                case "opa_bstatus":
                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("modal_form_list.status"),
                        oldValue: data?.opht_cold_value === "0" ? intl.get("modal_automation_list.history.inactive") : intl.get("modal_automation_list.history.active"),
                        newValue: data?.opht_cnew_value === "0" ? intl.get("modal_automation_list.history.inactive") : intl.get("modal_automation_list.history.active")
                    })
                case "opa_block_nid":
                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("modal_new_automation.create_activity_block"),
                        oldValue: data.opht_cold_value,
                        newValue: data.opht_cnew_value
                    })

                case "opa_bnot_have_deadline":
                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("modal_new_automation.without_deadline"),
                        oldValue: data?.opht_cold_value === "0" ? intl.get("modal_automation_list.history.inactive") : intl.get("modal_automation_list.history.active"),
                        newValue: data?.opht_cnew_value === "0" || data?.opht_cnew_value === "" ? intl.get("modal_automation_list.history.inactive") : intl.get("modal_automation_list.history.active")
                    })
                case "opafv_cvalue":
                    return intl.get("modal_automation_list.history.update_message_field")
                case "opa_cnotification_message":
                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("modal_new_automation.notification_params.notification_mesage"),
                        oldValue: data.opht_cold_value,
                        newValue: data.opht_cnew_value
                    })
                case "opa_cnotification_recipient_type":
                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("modal_new_automation.notification_params.who_notificate"),
                        oldValue: intl.get(`modal_new_automation.notification_params.${data.opht_cold_value}`),
                        newValue: intl.get(`modal_new_automation.notification_params.${data.opht_cnew_value}`)
                    })
                case "opa_ctrigger_type":
                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("modal_new_automation.when_a"),
                        oldValue: intl.get(`modal_new_automation.create_notification_params.${data.opht_cold_value}`),
                        newValue: intl.get(`modal_new_automation.create_notification_params.${data.opht_cnew_value}`)
                    })
                case "opa_from_block_nid":
                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("modal_new_automation.from_block"),
                        oldValue: data.opht_cold_value,
                        newValue: data.opht_cnew_value
                    })
                    case "opar_crecipinent_name":
                        return intl.get("modal_automation_list.history.update_message", {
                            field: intl.get("modal_new_automation.notification_params.name"),
                            oldValue: data.opht_cold_value,
                            newValue: data.opht_cnew_value
                        })
                case "opar_crecipinent_email":
                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("email"),
                        oldValue: data.opht_cold_value,
                        newValue: data.opht_cnew_value
                    })
                case "opa_observed_block_nid":
                    return intl.get("modal_automation_list.history.update_message", {
                        field: intl.get("modal_new_automation.in_block"),
                        oldValue: data.opht_cold_value === null ? intl.get("modal_new_automation.whatever_block_history") : data.opht_cold_value,
                        newValue: data.opht_cnew_value === null ? intl.get("modal_new_automation.whatever_block_history") : data.opht_cnew_value
                    })
                default:
                    return ""
            }
        }
        if (cAction === "deleted") {
            switch (data.opht_cfield) {
                case "opar_user_nid":
                    return intl.get("modal_automation_list.history.deleted_message", {
                        data: data.opht_cnew_value,
                        field: intl.get("modal_new_automation.notification_params.user_notificade"),
                    })
            }
        }

        //FORMS TEXT
        
        if(data.opht_changeable_type.includes("Form")){
            if (cAction === "created") {
                switch (data.opht_changeable_type) {
                    case "BlockForm":
                        return intl.get("modal_automation_list.history.create_message", { functionality: intl.get("modal_automation_list.history.form") })
                    case "BlockFormField":
                        return intl.get("modal_automation_list.history.add_field", { field: data.opht_cnew_value })
                    case "BlockFormResponsible":
                        return intl.get("modal_automation_list.history.update_message_not_old", {
                            field: intl.get("DashboardPage.responsibles"),
                            newValue: data.opht_cnew_value
                        })
                }
            }
            if(cAction === "update"){
                switch (data.opht_cfield) {
                    case "opbform_cdescription":
                        return intl.get("modal_automation_list.history.update_message", {
                            field: intl.get("modal_new_form.description_form"),
                            oldValue: data.opht_cold_value,
                            newValue: data.opht_cnew_value
                        })
                    case "opbform_cname":
                        return intl.get("modal_automation_list.history.update_message", {
                            field: intl.get("modal_new_form.form_name"),
                            oldValue: data.opht_cold_value,
                            newValue: data.opht_cnew_value
                        })
                    case "opbform_block_nid":
                        return intl.get("modal_automation_list.history.update_message", {
                            field: intl.get("modal_new_form.block"),
                            oldValue: data.opht_cold_value,
                            newValue: data.opht_cnew_value
                        })
                    case "opbform_ntime_value":
                    case "opbform_etime_ranger":
                        return intl.get("modal_automation_list.history.update_message", {
                            field: intl.get("modal_new_form.deadline_execution"),
                            oldValue: oResponseTranslate?.opht_cold_value,
                            newValue: oResponseTranslate?.opht_cnew_value
                        })
                    case "opbform_ballow_evidence":
                        return intl.get("modal_automation_list.history.update_message", {
                            field: intl.get("modal_new_form.allow_evidence_upload"),
                            oldValue: data.opht_cold_value === "1" ? intl.get("yes") : intl.get("no"),
                            newValue: data.opht_cnew_value === "1" ? intl.get("yes") : intl.get("no")
                        })
                    case "opbformf_bisrequired":
                    case data.opht_cfield.includes("opbformf_bisrequired|") && data.opht_cfield:
                        return intl.get("modal_automation_list.history.update_message_required", {
                            field: data.opht_cfield.split("|")[1],
                            oldValue: data.opht_cold_value === "1" ? intl.get("yes") : intl.get("no"),
                            newValue: data.opht_cnew_value === "1" ? intl.get("yes") : intl.get("no")
                        })
                    case data.opht_cfield.includes("opbformf_bisvisible|") && data.opht_cfield:
                        return intl.get("modal_automation_list.history.update_message_visibility", {
                            field: data.opht_cfield.split("|")[1],
                            oldValue: data.opht_cold_value === "1" ? intl.get("yes") : intl.get("no"),
                            newValue: data.opht_cnew_value === "1" ? intl.get("yes") : intl.get("no")
                        })
                    case "opbform_bis_active" :
                        return intl.get("modal_automation_list.history.functionality", {
                            action: data.opht_cold_value === "1" ? intl.get("modal_automation_list.history.inactived") : intl.get("modal_automation_list.history.actived"),
                            functionality: intl.get("modal_automation_list.history.form"),
                            
                        })
                }
            }
            if(cAction === "deleted" ){
                switch (data.opht_cfield) {
                    case "responsible":
                        return intl.get("modal_automation_list.history.deleted_message", {
                            data: data.opht_cold_value,
                            field: intl.get("DashboardPage.responsibles"),
                        })
                }
            }
        }

    }

    function fnOpenCreateNewFunctionality(data, bIsActive) {
        fnOpenModalNewFunctionality(data, bIsActive)
    }

    function fnCloseHistoryModal() {
        fnSetBIsOpenModalHistory(false)
        fnSetOCurrentHistoryData({})
    }
    function fnOpenHistoryModal(data) {
        // if(!bIsAutomation){
        //     console.log(data)
        //     fnSetBIsOpenModalHistory(true)
        //     return
        // }
        
        fnSetOCurrentHistoryData(data)
        fnSetBIsOpenModalHistory(true)
    }
    return (
        <>

            <RcmpModalAdd
                isOpen={bIsOpen}
                fnHandleCancel={fnCloseModal}
                title={title}
                fnHandleConfirm={fnCloseModal}
                showFooter={false}
                customWidth={848}
            >
                <div style={{ marginLeft: bIsAutomation ? "-10%" : "-4%" }} className={styles.modalContent}>
                    {!bDataLoadingRequest ?
                        <RcmpLoading className={bIsAutomation ? styles.spinnerAreaAutomation : styles.spinnerAreaForm} bShow={true} /> :
                        <>
                            {bCanChange && <div className={styles.newFormButton} onClick={fnOpenModalNewFunctionality}>
                                <PurePlusIcon fill={"#6CB6E3"} />
                                {
                                    <Typography type="h5" color="#6CB6E3">{cCreateNewFunctionality}</Typography>
                                }
                            </div>}

                            <div >
                                {!bIsAutomation ?
                                    <RcmpTableFormList data={aData} fnOpenNewFunctionality={fnOpenCreateNewFunctionality} bCanChange={bCanChange} fnOpenHistoryModal={fnOpenHistoryModal}/>
                                    :
                                    <RcmpTableFormList bIsAutomation={bIsAutomation} data={aData} fnOpenNewFunctionality={fnOpenCreateNewFunctionality} fnOnCloseModalList={bOnClose} fnOpenHistoryModal={fnOpenHistoryModal} bCanChange={bCanChange} />
                                }
                            </div>
                        </>
                    }
                </div>

            </RcmpModalAdd>

            {bIsOpenModalHistory && <RcmpHistoryModal aHeaders={aHeadersHistoryTable} nTargetId={oCurrentHistoryData.id} cTitle={oCurrentHistoryData.title} fnOnClose={fnCloseHistoryModal} bIsOpen={bIsOpenModalHistory} fnGetHistory={fnGetHistory} fnFormatTextHistory={fnFormatAutomationTextHistory} cTargetHistoryType={bIsAutomation ? "automation": "blockForm"} />}

        </>
    )
}